import { TsDOM as q } from '@/scripts/core/TsDOM'
import { type CartItems } from '@/scripts/cart/cart-items'
import { type CartDrawerItems } from '@/scripts/cart/cart-drawer-items'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { cartDebug } from '@/scripts/cart/optimistic-debug'

export class CartRemoveButton extends UcoastEl {
	static htmlSelector = 'cart-remove-button'
	constructor() {
		super()

		this.addEventListener('click', (event) => {
			event.preventDefault()
			// If removing a GWP or bundle item, skip re-adding it in this update cycle
			const lineEl = this.closest<HTMLElement>('[data-uc-cart-item]')
			const gwpOffer =
				this.getAttribute('data-gwp-offer') ||
				lineEl?.getAttribute('data-gwp-offer') ||
				''
			const bundleOffer =
				this.getAttribute('data-bundle-offer') ||
				lineEl?.getAttribute('data-bundle-offer') ||
				''
			if (
				(this.hasAttribute('data-gwp-item') && gwpOffer) ||
				bundleOffer
			) {
				window.__skipGwpAdditions = true
			}
			cartDebug('cart-remove-button:click', {
				index: q.ra(this, 'data-index'),
				gwpOffer,
				bundleOffer,
				skipGwpAdditions: window.__skipGwpAdditions,
			})
			const cartItems =
				q.oc<CartItems>(this, 'cart-items') ||
				q.rc<CartDrawerItems>(this, 'cart-drawer-items')
			cartItems.updateQuantity(q.ra(this, 'data-index'), '0')
		})
	}
}
